import classnames from 'classnames/bind';
import Table from 'components/Table';
import Typography from 'components/Typography';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from './ShareLogin.module.scss';

const cx = classnames.bind(styles);

const ShareLogin = ({ componentRef }) => {
  const {
    operatingClassroom: { students, password, name },
  } = useSelector(({ classroom }) => classroom);

  const { first_name = '', last_name } = useSelector(({ user }) => user);

  useEffect(() => {
    if (first_name) {
      document.title = `${last_name}${first_name.charAt(0)}_${name}`;
    }
  }, [first_name, last_name, name]);

  const tableColumns = useMemo(
    () => [
      {
        name: 'Username',
        width: '50%',
        renderer: (row) => <Typography type="h5">{row.username}</Typography>,
      },
      { 
        name: 'Student Name', 
        width: '50%', 
        renderer: (row) => <Typography type="h5">{row.studentName || ''}</Typography>,
      },
    ],
    [],
  );

  const sortArray = (data) =>
    data.sort((a, b) => {
      const aNumber = a.username.replace(/[^0-9]/g, '');
      const bNumber = b.username.replace(/[^0-9]/g, '');

      if (aNumber < bNumber) {
        return -1;
      }

      if (aNumber > bNumber) {
        return 1;
      }

      return 0;
    });

  const transformedStudents = students.map((username, index) => ({
    username, // assuming each student in `students` array is just a username string
    // studentName: `Student ${index + 1}`, // replace this with actual student name if available
  }));

  return (
    <>
      <Typography type="h4">Share Login Credentials</Typography>

      <Typography className={cx('description', 'mgt-15', 'mgb-25')}>
        Provide each student with a username and the password below. (Students will be able to change their password
        after they log in.)
      </Typography>

      <div className={styles.loginsContainer} ref={componentRef}>
        <div className={styles.passwordWrapper}>
          <Typography className={styles.subTitle}>Classroom:</Typography>
          <Typography>{name}</Typography>
        </div>

        <div className={styles.passwordWrapper}>
          <Typography className={styles.subTitle}>Password:</Typography>
          <Typography>{password}</Typography>
        </div>

        <div>
          <Typography className={styles.subTitle}>Username(s):</Typography>

          <Typography className={styles.description}>
            Usernames are autogenerated using the teacher’s last name and first initial followed by a sequential number.
          </Typography>

          <div className={styles.tableWrapper}>
            <Table columns={tableColumns} data={sortArray(transformedStudents) || []} className={styles.shareTable} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareLogin;
